import { Table } from 'reactstrap';
import styled from 'styled-components';

const ScrollingTable = styled(Table)`
  display: inline-block;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'fit-content')};
  max-width: 100%;
  max-height: 100%;
  overflow-y: auto;
  border-spacing: 0;
  border-collapse: separate;
  white-space: nowrap;
  border-top: 1px solid var(--table-border-color);
  td,
  th {
    border-right: 1px solid var(--table-border-color);
    border-bottom: 1px solid var(--table-border-color);
    border-top: none;
    &:last-of-type {
      border-right: none;
    }
  }
`;

export default ScrollingTable;
